
import addDriver from './requests/addDriver.js';
import deleteOrder from './requests/deleteOrder.js';
import getMe from './requests/getMe.js';
import getPredictions from './requests/getPredictions.js';
import updateItem from './requests/updateItem.js';
import addItem from './requests/addItem.js';
import deletePersonNotification from './requests/deletePersonNotification.js';
import getMyDriver from './requests/getMyDriver.js';
import getSettings from './requests/getSettings.js';
import updateOrder from './requests/updateOrder.js';
import addVendor from './requests/addVendor.js';
import deleteVendor from './requests/deleteVendor.js';
import getMyDriverOrders from './requests/getMyDriverOrders.js';
import getVendor from './requests/getVendor.js';
import updatePerson from './requests/updatePerson.js';
import createOrder from './requests/createOrder.js';
import deleteVendorNotification from './requests/deleteVendorNotification.js';
import getMyOrders from './requests/getMyOrders.js';
import getVendors from './requests/getVendors.js';
import updateVendor from './requests/updateVendor.js';
import deleteDriver from './requests/deleteDriver.js';
import getDispatchOrders from './requests/getDispatchOrders.js';
import getMyVendor from './requests/getMyVendor.js';
import stripeInitialize from './requests/stripeInitialize.js';
import deleteDriverNotification from './requests/deleteDriverNotification.js';
import getDrivers from './requests/getDrivers.js';
import getMyVendorOrders from './requests/getMyVendorOrders.js';
import updateDriver from './requests/updateDriver.js';
import deleteItem from './requests/deleteItem.js';
import getItems from './requests/getItems.js';
import getPeople from './requests/getPeople.js';
import updateDriverNotification from './requests/updateDriverNotification.js';
import getDriverReports from './requests/getDriverReports.js';
import createMulti from './requests/createMulti.js';
import updateSettings from './requests/updateSettings.js';
import updateBusinessHours from './requests/updateBusinessHours.js';
import completeStripe from './requests/completeStripe.js';

export default {
    completeStripe,
    createMulti,
    getDriverReports,
    updateBusinessHours,
    addDriver,
    deleteOrder,
    updateSettings,
    getMe,
    getPredictions,
    updateItem,
    addItem,
    deletePersonNotification,
    getMyDriver,
    getSettings,
    updateOrder,
    addVendor,
    deleteVendor,
    getMyDriverOrders,
    getVendor,
    updatePerson,
    createOrder,
    deleteVendorNotification,
    getMyOrders,
    getVendors,
    updateVendor,
    deleteDriver,
    getDispatchOrders,
    getMyVendor,
    stripeInitialize,
    deleteDriverNotification,
    getDrivers,
    getMyVendorOrders,
    updateDriver,
    deleteItem,
    getItems,
    getPeople,
    updateDriverNotification,
};